// Regex patterns to match with a URL path to force CSR to function.
const overrideCSRPaths = [];

export function overrideCSR(newRoute) {
  return overrideCSRPaths.some((p) => p.test(newRoute.path));
}

const openInNewTabPaths = [
  // Open the XML Feed pages in a new tab.
  /^\/feed\/blog/i,
  /^\/feed\/alert/i,
  /^\/feed\/advisories/i,
  // Open PDF / Image Links in a new tab.
  /^\/-\/media\/.*/i
];

export function openInNewTab(newRoute) {
  return openInNewTabPaths.some((p) => p.test(newRoute.path));
}
